import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import InputMask from 'react-input-mask';
import moment from 'moment';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function RegenerateFeeModal({
  regenerating,
  formData,
  setFormData,
  id,
  regenerateFeeTransaction,
  showTransaction,
  bin,
  onRegenerateFees,
  regenerateFees,
}) {
  const setModal = useContext(ModalContext);
  const [generateFees, setGenerateFees] = useState({
    label: '',
    value: 0,
    bin: '',
    year: '',
    period: '',
  });

  const currentYear = moment().year();

  const formatPeriod = data => {
    let val = '';
    switch (data) {
      case 0:
        val = '1st Quarter';
        break;
      case 1:
        val = '1st Quarter';
        break;
      case 2:
        val = '2nd Quarter';
        break;
      case 3:
        val = '3rd Quarter';
        break;
      case 4:
        val = '4th Quarter';
        break;
      default:
        val = '';
        break;
    }
    return val;
  };

  useEffect(() => {
    onRegenerateFees(id);
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      log_id: _.get(formData, 'log_id'),
    };

    regenerateFeeTransaction(id, args, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    setFormData({
      ...c.FORM_DATA,
      bin,
    });
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const amountOptions = regenerateFees.map(x => ({
    label: `${moment(_.get(x, 'date_processed')).format(
      'MM/DD/YYYY'
    )} ${'-'} ${_.get(x, 'amount')}`,
    value: x.id,
    bin: _.get(x, 'bin'),
    year: _.get(x, 'year'),
    period: formatPeriod(_.get(x, 'qtr_to')),
  }));

  const handleDropDownChange = key => e => {
    setGenerateFees(e);
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      bin: e.bin,
      year: e.year,
      period: e.period,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">Billing:</label>
            <Select
              options={amountOptions}
              placeholder="Select Billing"
              onChange={handleDropDownChange('log_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">BIN:</label>
            <InputMask
              readOnly
              placeholder="___-__-____-_______"
              className="form-control"
              maskChar=" "
              mask="999-99-9999-9999999"
              autoComplete="none"
              id="bin"
              name="bin"
              onChange={handleOnChange}
              value={_.get(formData, 'bin') || generateFees.bin}
              // {_.get(formData, 'bin') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Year:</label>
            <InputMask
              readOnly
              className="form-control"
              maskChar=" "
              autoComplete="none"
              id="year"
              name="year"
              onChange={handleOnChange}
              value={`${currentYear}` || generateFees.year}
              // {`${currentYear}`}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Period:</label>
            <InputMask
              readOnly
              className="form-control"
              maskChar=" "
              autoComplete="none"
              id="period"
              name="period"
              onChange={handleOnChange}
              value={'4th Quarter' || generateFees.period}
              // "4th Quarter"
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={regenerating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

RegenerateFeeModal.propTypes = {
  regenerating: PropTypes.bool.isRequired,
  regenerateFeeTransaction: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  onRegenerateFees: PropTypes.instanceOf(Function).isRequired,
  regenerateFees: PropTypes.instanceOf(Array).isRequired,
  id: PropTypes.string.isRequired,
  bin: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  regenerating: _.get(api, 'loading', []).indexOf(c.REGENERATE_FEES) > -1,
  regenerateFees: _.get(api, `${c.REGENERATE_FEES}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(RegenerateFeeModal);
